import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../../AccountForm.meta';
interface Props {
  index: number;
  isReadOnly?: boolean;
}

export const OwnershipPercentage = ({ index, isReadOnly = false }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormFields>();

  const errorFormKey =
    errors?.bankAccount?.OwnerModel && errors?.bankAccount?.OwnerModel[index]?.Percentage;

  return (
    <Controller
      control={control}
      name={`bankAccount.OwnerModel.${index}.Percentage`}
      render={({ field: { value, onChange } }) => (
        <InputNumberMask
          value={value}
          onChange={onChange}
          css={{ flex: 1 }}
          label="Ownership %"
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          maxLength={5}
          disabled={isReadOnly}
          formVariant={errorFormKey && 'error'}
          helperText={errorFormKey && errorFormKey?.message}
        />
      )}
    />
  );
};
